"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = require("./default");
exports.Default = default_1.default;
//# sourceMappingURL=index.js.map